import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/loading_new.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2312010b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container-detail" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "purpose-box" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "value-box" }
const _hoisted_6 = { class: "scenarios-box" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "new-loading wrong-question-loading"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "加载中…")
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.purpose.label), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.purpose.value), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.scenarios.label), 1),
            (_ctx.scenarios)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.scenarios.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "value-box",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.label), 1),
                      (_ctx.collection_key == 'user_head' && item.label == '收集内容')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "describe_img",
                            src: item.value
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: _normalizeClass(["describe", {
                  jump:
                    (_ctx.fatherKey === 'propertyInformation' || _ctx.fatherKey === 'userInformation') &&
                    item.key === 'collectContent'
                }]),
                            onClick: ($event: any) => (_ctx.jumpH5(item))
                          }, _toDisplayString(item.value), 11, _hoisted_11))
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
  ]))
}